import * as React from 'react';
import CardContainer from '../../../components/CardContainer';
import Devider from '../../../components/Devider';
import StepperFooter from '../../../components/StepperFooter';
import { observer } from 'mobx-react-lite';
import { Trans, useTranslation } from 'react-i18next';
import SocialMediaForm from './SocialMediaForm';
import SocialMediaModel from '../models/SocialMediaModel';
import StepLoaderWrapper from '../../../components/StepLoaderWrapper';
import { BodyText, H1 } from '../../../components/ui/Typography';
import { AnimatePresence, motion } from 'framer-motion';
import {
  fadeInUpVariants,
  staggerContainerVariants
} from '../../../components/animations/StepAnimations';
import { useState } from 'react';

interface FCProps {}

const SocialMediaStep: React.FC<FCProps> = observer(({}) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);
  const [isStepLoading, setIsStepLoading] = useState(false);

  const handleNextStep = () => {
    setIsVisible(false);
  };

  return (
      <StepLoaderWrapper
        loading={SocialMediaModel.isLoadingSocialProfiles}
        message={t('Loading social media accounts...')}>
        <AnimatePresence>
          {isVisible && (
            <motion.div
              initial="hidden"
              animate="visible"
              exit="hidden"
              variants={staggerContainerVariants}
            >
              <CardContainer>
                <motion.div variants={fadeInUpVariants}>
                  <H1>{t('Your social media accounts')}</H1>
                </motion.div>
                <div className="flex flex-col company-data">
                  <div className="relative">
                    <motion.div variants={fadeInUpVariants} className='mb-[50px]'>
                      <BodyText>
                        <Trans
                          i18nKey="socialMediaStep.description1"
                          defaults={`So that your visitors find you in the social media, you should link your channels.<br/>We have already found some for you and like to add more!`}
                          components={{ br: <br /> }}
                        />
                      </BodyText>
                    </motion.div>
                  </div>
                  <SocialMediaForm />
                  <motion.div variants={fadeInUpVariants}>
                    <StepperFooter
                      buttonId="social-save-next"
                      buttonGaEvent="social-save-next"
                      loading={isStepLoading}
                      onFormsValidationSuccess={async (formData, nextStep) => {
                        setIsStepLoading(true);
                        
                        let socialMediaData = formData.get('socialMediaForm') as {
                          facebook: string;
                          instagram: string;
                          linkedin: string;
                          pinterest: string;
                          tiktok: string;
                          x: string;
                          xing: string;
                          youtube: string;
                        };

                        SocialMediaModel.socialMediaWizardDataModel.setFormData({
                          business_url_facebook: socialMediaData.facebook,
                          business_url_instagram: socialMediaData.instagram,
                          business_url_linkedin: socialMediaData.linkedin,
                          business_url_pinterest: socialMediaData.pinterest,
                          business_url_tiktok: socialMediaData.tiktok,
                          business_url_x: socialMediaData.x,
                          business_url_xing: socialMediaData.xing,
                          business_url_youtube: socialMediaData.youtube
                        });

                        handleNextStep();
                        setTimeout(() => {
                          nextStep();
                          setIsStepLoading(false);
                        }, 300);
                      }}
                    />
                  </motion.div>
                </div>
              </CardContainer>
            </motion.div>
          )}
        </AnimatePresence>
      </StepLoaderWrapper>
  );
});

export default SocialMediaStep;
